import React from 'react';

const CanyonIcon = (props) => {
  return (
    <img
      alt="Wąwóz"
      src="/static/images/icons/tourist_attractions/canyon.svg"
      {...props}
    />
  );
};

export default CanyonIcon;
